<carousel>
	<slide *ngFor="let option of images">
		<img [src]="organizationService.dynamicUri(option)" />
	</slide>
</carousel>
